import { BaseClient } from '../client';
import { TGrupoConcessionaria } from './groupDealer.types';

export const getAllGroupDealers = async () => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return GroupsDealerMock;
	// }

	try {
		const response = await BaseClient.get<TGrupoConcessionaria[]>(`/GrupoConcessionarias`).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		console.error(error);
	}
};
